export default class AbortError extends Error {}

AbortError.prototype.name = "AbortError";
